/**
 * FAQ Accordion Functionality
 * Handles expand/collapse of FAQ items with proper ARIA attributes
 */

if (typeof window.FAQAccordion === 'undefined') {
class FAQAccordion {
  constructor() {
    this.faqContainer = document.getElementById('FAQ');
    if (!this.faqContainer) return;

    this.questionButtons = this.faqContainer.querySelectorAll('.faq__question');
    this.init();
  }

  init() {
    if (!this.questionButtons || this.questionButtons.length === 0) return;

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.questionButtons.forEach((button) => {
      button.addEventListener('click', (event) => this.handleToggle(event));
      button.addEventListener('keydown', (event) => this.handleKeyboard(event));
    });
  }

  handleToggle(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const answerId = button.getAttribute('aria-controls');
    const answerElement = answerId ? document.getElementById(answerId) : null;

    if (!answerElement || !(answerElement instanceof HTMLElement)) return;

    // If clicking an open item, close it
    if (isExpanded) {
      this.setExpanded(button, answerElement, false);
      return;
    }

    // Close all other items first
    this.closeAllItems();

    // Then open the clicked item
    this.setExpanded(button, answerElement, true);
  }

  closeAllItems() {
    this.questionButtons.forEach((button) => {
      const answerId = button.getAttribute('aria-controls');
      const answerElement = answerId ? document.getElementById(answerId) : null;

      if (answerElement && answerElement instanceof HTMLElement) {
        this.setExpanded(button, answerElement, false);
      }
    });
  }

  handleKeyboard(event) {
    // Allow Enter and Space to toggle
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    this.handleToggle(event);
  }

  setExpanded(button, answer, isExpanded) {
    button.setAttribute('aria-expanded', isExpanded);

    if (isExpanded) {
      answer.removeAttribute('hidden');
      button.closest('.faq__item').classList.add('is-open');
    } else {
      answer.setAttribute('hidden', '');
      button.closest('.faq__item').classList.remove('is-open');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FAQAccordion();
  });
} else {
  new FAQAccordion();
}

window.FAQAccordion = FAQAccordion;
}
